import React, { useState } from 'react';
import { useContractAssetSuggestions } from './useContractAssetSuggestions';
import { SuggestionsPickerBase } from '../SuggestionsPickerBase';

export const ContractAssetsPicker = (props) => {
  const { selected, ...restProps } = props;

  const [query, setQuery] = useState('');

  const [suggested, excluded, suggestionsLoading] = useContractAssetSuggestions(
    {
      context: undefined,
      selected,
      query
    }
  );

  return (
    <SuggestionsPickerBase
      {...restProps}
      suggestions={suggested}
      query={query}
      setQuery={setQuery}
      primaryKey="display_name"
      placeholder="Start typing an asset name..."
      allowAddingOfNewSuggestions={false}
      loading={suggestionsLoading}
      excludedSuggestions={excluded}
    />
  );
};
